/* eslint-disable import/prefer-default-export */
import ComponentStyles from './Styles';

export const Styles = ComponentStyles;
